// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText___0Wgg","richText__imageWrap":"RichText_richText__imageWrap__rHrVj"};